import Crud from '../views/Establishment/Crud'
import Entity from '../views/Establishment/Add'

let routes = {
    path: '/establishments',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/establishments/add',
            name: 'NewEstablishment',
            component: Entity,
            meta: {
                pageTitle: 'establishment.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'establishment.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/establishments/edit/:id?',
            name: 'EditEstablishment',
            component: Entity,
            meta: {
                pageTitle: 'establishment.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'establishment.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/establishments',
            name: 'list-establishments',
            component: Crud,
            meta: {
                pageTitle: 'establishment.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'establishment.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
